import goodflip_care_program_json from "./goodflip_care_program_json";
import liver_forever_program_json from "./liver_forever_program_json";
import acti_liver_program_json from "./acti_liv_program_json";
import anaya_care_program_json from "./anaya_care_program_json";
import anyra_care_program_json from "./anyra_care_program_json";

import { SupportProgramType } from "src/types/supportProgram.types";

const supportPrograms: Record<string, SupportProgramType> = {
  "goodflip-care-program": goodflip_care_program_json,
  "liver-forever-program": liver_forever_program_json,
  "acti-liv-program": acti_liver_program_json,
  "anaya-care-program": anaya_care_program_json,
  "anyra-care-program": anyra_care_program_json,
};

export default supportPrograms;
